import { Engine } from '../../core/Engine';
import { ToggleLockCommand } from '../Commands';

export class ToggleLockCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: ToggleLockCommand) {
        const obj = this.engine.find(command.uuid);
        if (obj) {
            obj.isLocked = !obj.isLocked;
        }
    }
}
